@if (!!line) {
  <div
    class="flex gap-2 items-center"
    [ngClass]="{'cursor-pointer' : isPointer}"
    (click)="isPointer && onLineClick.emit(line)"
    >
    <img
      [src]="line.agencyId | agencyLogo"
      [attr.alt]="line.agencyName"
      class="h-6"
      [ngClass]="{'max-w-6' : showLineCity}"
    (click)="
      !!onAgencyClick.observed
        ? onAgencyClick.emit(line.agencyId)
        : onLineClick.emit(line); $event.stopPropagation()
    "
      />
      <span class="bg-gray px-1 py-0.5 rounded-lg">{{ line.agencyId === 2 ? line.routeDesc : line.routeName }}</span>
      @if (showLineCity) {
        <span class="">{{ line.cityName }}</span>
      }
      @if (isAutoComplete) {
        <span class="bg-gray px-1 py-0.5 rounded-lg"> {{ line.routeLongName }}</span>
      }
      @if (line.specialData?.isAccessible) {
        <ng-icon [name]="line.specialData?.isCallNeeded ? 'wheelchair-move-phone' : 'wheelchair-move'" [matTooltip]="line.specialData?.isCallNeeded ? accessibleWithOrderTooltipText : accessibleTooltipText"/>
      }
      @if (destination) {
        <span class="!text-sm !font-normal">{{
          destination
        }}</span>
      }
    </div>
  }

  